import type { BadgeProps } from '@eliadmin/core/src/components/ui/badge';

import { Badge } from '@eliadmin/core/src/components/ui/badge';
import { useCartQueryOpts } from '@eliadmin/core/src/hooks/cart/use-cart';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { useQuery } from '@tanstack/react-query';

export type CartBadgeProps = BadgeProps & {
  className?: string;
};
// TODO: fix styling on long texts ?
export function CartBadge({ className, ...props }: CartBadgeProps) {
  const { data: cart } = useQuery(useCartQueryOpts());

  const count = cart?.count ?? 0;
  const countText =
    count > 99 ? (
      <span>
        99<sup>+</sup>
      </span>
    ) : (
      count
    );

  return (
    <Badge
      className={cn(
        'absolute right-0 top-0 h-5 w-5 -translate-y-1/2 translate-x-1/2 justify-center bg-destructive-foreground text-[10px] text-white',
        'ea-cart-button__badge',
        className,
      )}
      size="circle"
      {...props}
    >
      {countText}
    </Badge>
  );
}
